import { render, staticRenderFns } from "./ClientBrands.vue?vue&type=template&id=1164cd1a&scoped=true"
import script from "./ClientBrands.vue?vue&type=script&lang=ts"
export * from "./ClientBrands.vue?vue&type=script&lang=ts"
import style0 from "./ClientBrands.vue?vue&type=style&index=0&id=1164cd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1164cd1a",
  null
  
)

export default component.exports